import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";

/** Posición (concepto) de la consulta estilo ME23N del contrato. */
export interface ConsultaConcepto {
  lineaPedido: string;
  descripcion: string;
  cantidad: number;
  unidad: string | null;
  valorUnitario: number;
  importe: number;
  cuentaContable: string | null;
  centroCostos: string | null;
}

/** Consulta (solo lectura) del contrato anualizado · cabecera + posiciones + disponibilidad. */
export interface ConsultaContrato {
  clave: string;
  proveedorNombre: string;
  proveedorRfc: string;
  proveedorClave: string | null;
  moneda: string;
  estatus: string | null;
  fecha: string | null;
  subTotal: number;
  impuestos: number;
  total: number;
  consumido: number;
  disponible: number;
  version: number;
  esUltimaVersion: boolean;
  conceptos: ConsultaConcepto[];
}

/**
 * Contrato Anualizado (CA) · asocia el contrato anualizado a la solicitud por su
 * clave en SAP. El backend busca el contrato, deriva el proveedor y devuelve
 * el detalle actualizado de la solicitud.
 */
export const contratoAnualizadoApi = {
  seleccionar: (id: string, clave: string) =>
    axiosClient
      .patch<SolicitudDetalle>(`/api/solicitudes/${id}/contrato-anualizado`, { clave })
      .then((r) => r.data),

  consultar: (clave: string) =>
    axiosClient
      .get<ConsultaContrato>(`/api/solicitudes/consulta/contrato-anualizado/${encodeURIComponent(clave)}`)
      .then((r) => r.data),
};
